<template>
<div class="container">
<div class="row">
	<div class="col-5" v-for="v in fy" @click="go(v)" :key="v.id">
		<img :src="picurl+v.pic" :alt="v.title"/>
		<h4>{{v.title}}</h4>
	</div>
</div>
</div>	
</template>

<style scoped>
.col-5{padding:1%;margin-bottom: 1rem;}
img{height:120px;width:100%;border:1px solid #eee;border-bottom:0;}
.col-5 h4{font-weight: 500;text-align:center;
	border-left:1px solid #eee;
	border-right:1px solid #eee;
	border-bottom:1px solid #eee;
	line-height: 1.2rem;
	padding-bottom:1rem;
	height:3.9rem;
	overflow: hidden;
	-webkit-margin-before:0;
	margin-top:-0.5rem;
}
</style>

<script>

export default {
	data(){
		return {
			mydata:mydata,
			fy:"",
			picurl:picurl,
		}
	},
	created:function(){
		 window.scrollTo(0,0);
		this.init();
	},
	watch: {
      '$route': 'init'
    },
	methods:{
		init:function(){
			var _this=this;
			var data={
				nid:this.$route.params.id,
			}
			// var nav="";
			// switch(data.nid){
			// 	case "9":
			// 	nav="优越环境";
			// 	break;
			// 	case "14":
			// 	nav="企业荣誉";
			// 	break;
			// 	case "15":
			// 	nav="精良设备";
			// 	break;  
			// 	default:
			// 	nav="第一健康"; 
			// }
 			//this.mydata.nav=nav;
 			if(fun.cache(fun.url())){
 				this.fy=fun.cache(fun.url());return;
 			}
            fun.post(api+"get_fy",data,function(d){
            	if(d.status==1){
            		_this.fy=d.info;
            		fun.cache(fun.url(),d.info);
            	}else{
            		_this.$toast(d.info);
            	}
            })
		},
		go:function(v){
			var nid=this.$route.params.id;
            if(nid!=9){return false;}
			var path='/thm/pic/n/9/fid/'+v.id+'/title/'+encodeURI(v.title);
			this.$router.push(path);
		}
	}
}
	
</script>


// WEBPACK FOOTER //
// src/components/thm/fy.vue